"use strict";

import React, { useState , useEffect} from "react";
import { api, reLoadPage, token } from "../services/config";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css";
import axios from "axios";

export const Reports  = (props) => {

  const [data, setData] = useState(null); // جهت مقدار تیبل

  useEffect(() => {
  
    const fetchData = async () => {
      try {
        const response = await api.get('gateway/payments', {
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'authorization': `Bearer ${localStorage.getItem('login')}`
          }
      })
      setData(response.data.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);  
 



  
  const changeDate = (dateString) => {

    let parts = dateString.split(" ");

    let datePart = parts[0]; // Contains "1402-11-13"
    let timePart = parts[1]; // Contains "20:03"

    return { datePart, timePart }
  }

  const [isDark, setIsDark] = useState(
    () =>
      typeof window !== "undefined" && document.body.classList.contains("dark")
  );

  useEffect(() => {
    const checkDark = () => setIsDark(document.body.classList.contains("dark"));
    checkDark();
    const observer = new MutationObserver(() => {
      checkDark();
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="flex flex-col">
    <div className="w-[95%] mt-10 mx-auto">
      <h1
  className="
    relative inline-block text-3xl font-bold mb-6 
    text-[#0010c6] dark:text-white
    after:content-[''] after:block after:w-full after:h-[4px] 
    after:bg-[#0010c6] after:mt-[10px] dark:after:bg-[#ffffff]
  "
>
        گزارش لینک دریافت وجه
      </h1>
     
    </div>
  
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg bg-white dark:bg-[#161B22]">
              <table className="min-w-full divide-y divide-gray-300 dark:divide-gray-700">
                {/* ---- header ---- */}
                <thead className="bg-[#E8F0FE] dark:bg-[#1E2329]">
                  <tr>
                    <th
                      scope="col"
                      className="py-4 pl-4 pr-3 text-center text-sm font-semibold text-gray-900 dark:text-gray-300 sm:pl-6"
                    >
                      تاریخ
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-4 text-center text-sm font-semibold text-gray-900 dark:text-gray-300"
                    >
                      ساعت
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-4 text-center text-sm font-semibold text-gray-900 dark:text-gray-300"
                    >
                      مبلغ (ریال)
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-4 text-center text-sm font-semibold text-gray-900 dark:text-gray-300"
                    >
                      شماره موبایل
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-4 text-center text-sm font-semibold text-gray-900 dark:text-gray-300"
                    >
                      وضعیت
                    </th>
                  </tr>
                </thead>
  
                {/* ---- body ---- */}
                <tbody>
                  {data?.length > 0 ? (
                    data.map((person, index) => (
                      <tr
                        key={person.id}
                        className={`${
                          index % 2 === 0
                            ? "bg-white dark:bg-[#1E2329]" // زوج
                            : "bg-[#F8FAFC] dark:bg-[#161B22]" // فرد
                        }`}
                      >
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-200 text-center">
                          {changeDate(person.created_at).datePart}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-200 text-center">
                          {changeDate(person.created_at).timePart}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-200 text-center">
                          {new Intl.NumberFormat("fa-IR").format(person.amount)}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-200 text-center">
                          {person?.user?.mobile}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-200 text-center">
                          {person.status_text}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                        className="py-6 text-center text-gray-500 dark:text-gray-400"
                      >
                        داده‌ای جهت نمایش وجود ندارد.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  );
};

